const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSortingAsc(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 8 10",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsSerif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 1.41421
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-6.00091,-5.01156)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Shape-4-copy-4",
    serifId: "Shape 4 copy 4",
    transform: "matrix(1,0,0,1,-603.001,-612.987)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M609.442,623.897C609.811,623.897 616.294,623.897 616.549,623.897C616.879,623.897 617.125,624.095 616.932,624.29C616.777,624.447 613.653,627.578 613.386,627.845C613.21,628.021 612.791,628.018 612.616,627.845C612.42,627.653 609.279,624.51 609.061,624.283C608.901,624.116 609.078,623.897 609.442,623.897Z",
    style: {
      fill: "rgb(228,228,228)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Shape-4-copy-41",
    serifId: "Shape 4 copy 4",
    transform: "matrix(1,0,0,1,-603.001,-612.987)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M609.442,622.077C609.811,622.077 616.294,622.077 616.549,622.077C616.879,622.077 617.125,621.879 616.932,621.684C616.777,621.527 613.653,618.396 613.386,618.129C613.21,617.954 612.791,617.957 612.616,618.129C612.42,618.321 609.279,621.464 609.061,621.692C608.901,621.858 609.078,622.077 609.442,622.077Z",
    style: {
      fill: "rgb(115,115,115)"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSortingAsc);
export default __webpack_public_path__ + "static/media/sorting_asc.40700db8226f78c74015e1bacf8f5403.svg";
export { ForwardRef as ReactComponent };